enum CostUnitCodeEnum {
  APPRAISER = 2,
  APPRAISER_AUXILIARY = 23,
  COMMON = 11,
  COMPENSATION = 22,
  COURT_FEES = 24,
  CUSTOM = 1,
  DEBASEMENT = 6,
  DEDUCTIBLE = 21,
  DEREGISTRATION_COSTS = 29,
  DISBURSEMENT = 25,
  DOWNTIME = 8,
  ESTIMATECOST = 3,
  FUEL_CONTENTS = 30,
  INTEREST = 28,
  LAWYER_FEES_ADVERSARY = 26,
  LAWYER_FEES_OWN = 27,
  LICENSE_COST = 20,
  OTHERS = 12,
  RENTVEHICLE = 7,
  REPAIR = 4,
  REPLACEMENT = 5,
  STANDFEE = 10,
  TOWAGE = 9
}

export default CostUnitCodeEnum;
